import style from "./style.scss";
import { mergeClasses } from "../../../../../../components/helpers";

const VoltageRangeDisplay = ({ maxVolts, maxWatts }) => {
  const volts = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(typeof maxVolts === "number" && maxVolts >= 0 ? maxVolts : 0);

  return (
    <div class={style.voltageRange}>
      <div class={style.heading}>Charging Voltage</div>
      <div class={style.main}>
        <div class={style.custom}>Custom</div>

        <div class={style.selectable}>
          <div class={style.volts}>
            {volts}
            <span class={style.units}>V</span>
          </div>
          <div class={style.arrow} />
        </div>

        <div class={style.description}>
          Wait 10 seconds between charging voltage or power changes to protect
          your device.
        </div>
        <div class={style.chargingPower}>Charging Power</div>

        <div class={style.selectable}>
          <div class={style.watts}>{maxWatts}W</div>
          <div class={style.arrow} />
        </div>
      </div>
    </div>
  );
};

export default VoltageRangeDisplay;
